import reduce from 'lodash/reduce';
import round from 'lodash/round';
import isEmpty from 'lodash/isEmpty';
import Moment from 'moment';

import { CONNECT_DISCONNECT_ID } from '../Constants/StaticUUIDs';

export default class AssetUtils {
  handleInfoBoxOpenClose(assetID, isOpen) {
    return reduce(
      isOpen,
      (acc, val, key) => {
        if (!isOpen[assetID]) {
          acc[assetID] = true;
        } else if (key === assetID) {
          acc[key] = !val;
        } else {
          acc[key] = false;
        }
        return acc;
      },
      {}
    );
  }
  getAssetOnlineTime(timestamp) {
    return Moment(timestamp).toNow(true);
  }
  getAssetLastUpdatedAt(lastUpdated) {
    if (!lastUpdated) return;
    return Moment(lastUpdated).format('YYYY-M-D');
  }
  getAssetCreatedAt(createdAt) {
    if (!createdAt) return;
    return Moment(createdAt).format('YYYY-M-D');
  }
  getAssetActivatedOn(activatedOn) {
    if (!activatedOn) return '--';
    return Moment(activatedOn).format('YYYY-M-D');
  }
  parseDateToYearMonthDay(dateString) {
    if (!dateString) return '--';
    return Moment(dateString).format('YYYY-M-D');
  }
  parseGpsForDisplay(input, axis) {
    if (typeof input !== 'number' || !axis) {
      return input;
    }
    const positiveSymbol = axis == 'latitude' ? 'N' : 'E';
    const negativeSymbol = axis == 'latitude' ? 'S' : 'W';
    const directionSymbol = input >= 0 ? positiveSymbol : negativeSymbol;
    return `${Math.abs(round(input, 1))}\u00b0${directionSymbol}`;
  }
  getConnectivityFromShadow({ shadow = {} } = {}) {
    if (!Object.keys(shadow).length) return;

    const { signalCollections } = shadow;
    const { signals: [{ value = '' }] = [{}] } =
      signalCollections.find((s) => s._id === CONNECT_DISCONNECT_ID) || {};
    return value;
  }
  getOnlineTimeFromShadow({ shadow = {} }) {
    if (!Object.keys(shadow).length) return;
    const { signalCollections = [] } = shadow;
    const { timestamp = '' } =
      signalCollections.find((s) => s._id === CONNECT_DISCONNECT_ID) || {};
    return Moment(timestamp).toNow(true);
  }
  getActiveSignalsFromShadow({ shadow = {} }) {
    const { signalCollections } = shadow;
    if (isEmpty(signalCollections)) return 0;

    return signalCollections.reduce((active, { _id, signals }) => {
      if (isEmpty(signals)) return active;
      _id !== CONNECT_DISCONNECT_ID && (active += signals.length);
      return active;
    }, 0);
  }
  parseLastUpdatedForDetails(lastUpdated) {
    if (!lastUpdated) return;
    return Moment(lastUpdated).format('MMMM D, YYYY hh:mm:ss a');
  }
}
